/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sec_Pg_Ledger_YesInputs */

const en_mk_sec_pg_ledger_yes = /** @type {(inputs: Mk_Sec_Pg_Ledger_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running`)
};

const id_mk_sec_pg_ledger_yes = /** @type {(inputs: Mk_Sec_Pg_Ledger_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berjalan`)
};

/**
* | output |
* | --- |
* | "Running" |
*
* @param {Mk_Sec_Pg_Ledger_YesInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sec_pg_ledger_yes = /** @type {((inputs?: Mk_Sec_Pg_Ledger_YesInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sec_Pg_Ledger_YesInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sec_pg_ledger_yes(inputs)
	return en_mk_sec_pg_ledger_yes(inputs)
});